import { Select, SelectItem } from "@/components/ui/select";
import { GetAllVideoInsightsReq } from "@/api/studio/insights/api";

/* Prop Types */
interface SelectSortVideoReportsProps {
  orderBy: GetAllVideoInsightsReq["orderBy"];
  sortBy: GetAllVideoInsightsReq["sortBy"];
  setOrderBy: (value: GetAllVideoInsightsReq["orderBy"]) => void;
  setSortBy: (value: GetAllVideoInsightsReq["sortBy"]) => void;
}

/*
 * SelectSortVideoReports component
 *
 * Sorts the video report cards by Attention score or asset name.
 * Owns the combined logic of setting both orderBy and sortBy together.
 */
export const SelectSortVideoReports = ({ orderBy, sortBy, setOrderBy, setSortBy }: SelectSortVideoReportsProps) => {
  /* Handlers */
  const handleOnChange = (value: string) => {
    switch (value) {
      case "desc":
        setOrderBy("attention");
        setSortBy("desc");
        break;
      case "asc":
        setOrderBy("attention");
        setSortBy("asc");
        break;
      case "nameAsc":
        setOrderBy("name");
        setSortBy("asc");
        break;
      case "nameDesc":
        setOrderBy("name");
        setSortBy("desc");
        break;
      default:
        break;
    }
  };

  const selectValue = orderBy === "name" ? (sortBy === "asc" ? "nameAsc" : "nameDesc") : (sortBy ?? "desc");

  /* Render */
  return (
    <Select onChange={handleOnChange} value={selectValue}>
      <SelectItem value="desc">Highest score</SelectItem>
      <SelectItem value="asc">Lowest score</SelectItem>
      <SelectItem value="nameAsc">Asset name A-Z</SelectItem>
      <SelectItem value="nameDesc">Asset name Z-A</SelectItem>
    </Select>
  );
};
